import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import imgTwo from "../../../assets/images/book-library/a-conspiracy-of-silence.jpg"

const BookList = () => {
  const books = useStaticQuery(graphql`
    query MyBookLibraryQueery {
      allBookLibraryJson {
        edges {
          node {
            id
            author
            url
            name
            img {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  placeholder: BLURRED
                  transformOptions: { cropFocus: CENTER }
                  aspectRatio: 0.7
                )
              }
            }
          }
        }
      }
    }
  `)

  function getBooks(books) {
    const booksArray = []

    books.allBookLibraryJson.edges.forEach((book, index) => {
      booksArray.push(
        <a
          key={book.node.id}
          href={book.node.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <ColumnWrapper key={index} gap={"1.5rem"}>
            <BookImgWrapper>
              <Image image={getImage(book.node.img)} alt={book.node.name} />
            </BookImgWrapper>
            <BookTitle>{book.node.name}</BookTitle>
            <Author>{book.node.author}</Author>
          </ColumnWrapper>
        </a>
      )
    })

    // books.allBookLibraryJson.edges.foreach((book, index) => {
    //   booksArray.push(
    //     <ColumnWrapper key={index}>
    //       <BookImgWrapper>
    //         <Image src={getImage(book.node.img)} alt={book.node.name} />
    //       </BookImgWrapper>
    //       <BookTitle>{book.name}</BookTitle>
    //       <Author>{book.author}</Author>
    //     </ColumnWrapper>
    //   )
    // })

    return booksArray
  }
  return (
    <>
      <MainContainer>
        <ColumnWrapper gap={"3rem"}>
          <ColumnWrapper>
            <Title>Featured Books</Title>
            <Description>
              At Writers Way Solutions, we Believe every story has the power to
              transform-whether
              <Br /> you're escaping into an epic fantasy
            </Description>
          </ColumnWrapper>
          <GridWrapper>
            {getBooks(books)}
            {/* <BookWrapper> */}
            {/* {bookLibrary.map((book, index) => (
              <ColumnWrapper key={index}>
                <BookImgWrapper>
                  <Img src={book.img} alt={book.name} />
                </BookImgWrapper>
                <BookTitle>{ book.name }</BookTitle>
                <Author>{ book.author }</Author>
              </ColumnWrapper>
            ))} */}

            {/* </BookWrapper> */}
          </GridWrapper>
        </ColumnWrapper>
      </MainContainer>
    </>
  )
}

export default BookList

const MainContainer = styled.main`
  padding: 6rem calc((100vw - 1200px) / 2);
  /* padding-bottom: 0rem; */
  width: 100%;
  height: auto;
  /* background: #EAF2F8; */
  background: #fff;
  position: relative;
  gap: ${({ gap }) => (gap ? gap : "1rem")};

  @media screen and (max-width: 1249px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    box-sizing: border-box;
  }

  @media screen and (max-width: 767px) {
    height: auto;
    flex-direction: column;
  }

  @media screen and (max-width: 500px) {
    padding-top: 3rem;
  }
`

const Container = styled.div`
  /* padding: 4rem calc((100vw - 1200px) / 2);
  background: #5890e1; */
  width: 100%;
`

// const AbsoluteContainer = styled.div`
//  width: 100%;
//  /* background: red; */
//  max-height: 300px;
// `

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
`
const RowWrapper = styled.div`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
`

const Br = styled.br`
  display: flex;
  @media screen and (max-width: 968px) {
    display: none;
  }
`

const Title = styled.h1`
  /* color: #fff; */
  color: ${props => props.theme.colors.accent7};
  font-size: 36px;
  text-align: center;

  @media screen and (max-width: 767px) {
    font-size: 3rem;
  }

  @media screen and (max-width: 600px) {
    font-size: 2rem;
  }
`

const Description = styled.p`
  /* color: #fff; */
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.colors.dark4};

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  width: 100%;
  height: auto;
  gap: 1.5rem;
  /* background-color: red; */
`
const BookWrapper = styled.div`
  max-height: 400px;
  height: 400px;
  /* background: red; */
`

const BookImgWrapper = styled.div`
  width: 100%;
  min-height: 400px;
  max-height: 400px;
  border-radius: 16px;
  overflow: hidden;
  background-color: #999;
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`

const Image = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
  /* border-radius: 16px; */
  -o-object-fit: cover;
  object-fit: cover;
   transition: transform 0.3s ease-in-out; /* smooth animation */

  &:hover {
    transform: scale(1.05); /* zooms in slightly */
  }
`

const BookTitle = styled.h5`
  font-size: 16px;
  font-weight: 500;
  color: #111;
  text-align: center;
`
const Author = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #111;
`
